module.exports = __webpack_public_path__ + "img/launch_contract.5073fdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/launch_contract.png
// module id = Odad
// module chunks = 1 87